module.exports = __webpack_public_path__ + "img/stripe.8088361d.png";